import BookingForm from "@/components/BookingForm";
import SharedNavbar from "@/components/SharedNavbar";
import { ShieldCheck, CheckCircle2, Droplets, Coffee, Star } from "lucide-react";

const LOGO_URL = "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-23/prod_agent_3a0812e8-cabc-4e60-9023-9eb878dbad11/ds_logo_transparent_1343324419e041449c280c0bfa45d1f3.png";

const images = [
  "https://images.unsplash.com/photo-1664623770970-a49e994b096b?w=800&q=80",
  "https://images.unsplash.com/photo-1678473015808-2fb2ea3139ed?w=800&q=80",
  "https://images.unsplash.com/photo-1581631059710-7b30fcd0e8d8?w=800&q=80",
  "https://images.unsplash.com/photo-1625343517206-44d93e5f7953?w=800&q=80",
];

export default function Flexschutz() {
  return (
    <div className="min-h-screen bg-background">
      <SharedNavbar />

      {/* Hero */}
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-red-900 py-20 text-white">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="max-w-3xl">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white/80">
              <ShieldCheck className="h-3.5 w-3.5 text-red-400" />
              DS Logistik Zusatzservice
            </div>
            <h1 className="text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">
              Fleckenschutz<span className="text-red-400">®</span>
            </h1>
            <p className="mt-4 text-xl font-medium text-white/80">Professioneller Schutz für Ihre neuen Polstermöbel</p>
            <p className="mt-6 max-w-2xl text-base leading-7 text-white/65">
              Direkt nach der Lieferung und Montage Ihres neuen Sofas oder Polstermöbels schützen wir es mit einer professionellen Schutzimprägnierung — gegen Flecken, Kaffee, Wasser, Fett und alltägliche Verschmutzungen. Mit <strong className="text-white">3 Jahren Schutzgarantie</strong>.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <button
                onClick={() => { const el = document.getElementById("termin-anfragen"); if(el){ el.scrollIntoView({behavior:"smooth",block:"start"}); setTimeout(()=>{ const f = document.getElementById("booking-name"); if(f) f.focus(); }, 600); }}}
                className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white shadow-[0_8px_24px_-10px_rgba(200,25,11,0.6)] hover:-translate-y-px transition-all"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg>
                Jetzt anfragen
              </button>
              <a href="https://wa.me/41798883262" target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-white shadow-lg hover:scale-105 transition-transform">
                <svg viewBox="0 0 24 24" className="h-5 w-5 fill-white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Jetzt anfragen
              </a>
              <a href="mailto:andre.stalder@ds-logistik.ch"
                className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-6 py-3 text-sm font-bold text-white hover:bg-white/20 transition-colors">
                andre.stalder@ds-logistik.ch
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Was ist Fleckenschutz */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Was ist Fleckenschutz®?</p>
              <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl">Unsichtbarer Schutz. Sichtbarer Unterschied.</h2>
              <p className="mt-5 text-base leading-7 text-muted-foreground">
                Fleckenschutz® ist eine professionelle Schutzimprägnierung, die direkt nach der Montage Ihrer neuen Polstermöbel aufgetragen wird. Die spezielle Formel bildet eine unsichtbare Schutzschicht auf dem Textilgewebe, die Flüssigkeiten, Fette und Schmutzpartikel effektiv abweist.
              </p>
              <p className="mt-4 text-base leading-7 text-muted-foreground">
                Die Behandlung dauert nur wenige Minuten und wird von unseren geschulten Monteuren direkt bei Ihnen zu Hause durchgeführt — ohne Aufwand für Sie.
              </p>
              <div className="mt-8 grid grid-cols-2 gap-4">
                {[
                  { icon: Droplets, label: "Wasserdicht", text: "Flüssigkeiten perlen einfach ab" },
                  { icon: Coffee, label: "Kaffee & Wein", text: "Keine bleibenden Flecken" },
                  { icon: ShieldCheck, label: "3 Jahre Garantie", text: "Voller Schutz garantiert" },
                  { icon: Star, label: "Unsichtbar", text: "Verändert Look & Feel nicht" },
                ].map(({ icon: Icon, label, text }) => (
                  <div key={label} className="rounded-2xl border border-border/60 bg-card p-4">
                    <Icon className="mb-2 h-5 w-5 text-primary" />
                    <p className="text-sm font-semibold text-foreground">{label}</p>
                    <p className="mt-1 text-xs leading-5 text-muted-foreground">{text}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {images.map((src, i) => (
                <div key={i} className="overflow-hidden rounded-2xl aspect-square">
                  <img src={src} alt={`Fleckenschutz Beispiel ${i + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Wie funktioniert es */}
      <section className="bg-muted/40 py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="text-center mb-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Ablauf</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl">So einfach funktioniert es</h2>
          </div>
          <div className="grid gap-6 sm:grid-cols-3">
            {[
              { step: "01", title: "Möbel wird geliefert", text: "DS Logistik liefert und montiert Ihre neuen Polstermöbel wie gewohnt — pünktlich und professionell." },
              { step: "02", title: "Fleckenschutz® wird aufgetragen", text: "Direkt im Anschluss trägt unser Monteur die Schutzimprägnierung gleichmässig auf alle Polsterflächen auf." },
              { step: "03", title: "3 Jahre sorglos geniessen", text: "Kaffee, Wein, Wasser — alles perlt ab. Bei hartnäckigen Flecken greift unsere 3-Jahres-Garantie." },
            ].map(({ step, title, text }) => (
              <div key={step} className="rounded-3xl border border-border/60 bg-card p-8">
                <p className="font-mono text-4xl font-bold text-primary/20">{step}</p>
                <h3 className="mt-4 text-lg font-bold text-foreground">{title}</h3>
                <p className="mt-2 text-sm leading-6 text-muted-foreground">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Geeignet für */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-foreground sm:text-4xl">Geeignet für alle Polstermöbel</h2>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {["Sofas & Couches","Sessel","Esszimmerstühle","Polsterbetten","Ottomanen","Schlafzimmermöbel","Bürostühle","Autositze"].map((item) => (
              <span key={item} className="rounded-full border border-border/60 bg-card px-5 py-2.5 text-sm font-medium text-foreground">
                {item}
              </span>
            ))}
          </div>
        </div>
      </section>

      
      {/* Termin & Anfrage */}
      <section className="py-16 bg-muted/30 border-y border-border/40">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <div className="text-center mb-10">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Jetzt buchen</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground">Termin anfragen</h2>
            <p className="mt-3 text-muted-foreground">Wählen Sie Service, Datum und Uhrzeit — wir melden uns innerhalb von 24 Stunden.</p>
          </div>
          <BookingForm defaultService="Fleckenschutz" />
        </div>
      </section>

      {/* CTA */}
      <section className="bg-foreground py-16 text-white">
        <div className="mx-auto max-w-3xl px-5 text-center lg:px-8">
          <CheckCircle2 className="mx-auto mb-4 h-10 w-10 text-red-400" />
          <h2 className="text-2xl font-bold sm:text-3xl">Fleckenschutz® bei Ihrer nächsten Lieferung</h2>
          <p className="mt-4 text-white/65">Fragen Sie bei Ihrer Bestellung einfach nach — wir kümmern uns um den Rest.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a href="https://wa.me/41798883262" target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-white hover:scale-105 transition-transform">
              WhatsApp: 079 888 32 62
            </a>
            <a href="mailto:andre.stalder@ds-logistik.ch"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-6 py-3 text-sm font-bold text-white hover:bg-white/20 transition-colors">
              E-Mail anfragen
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-border/40 bg-background py-6 text-center">
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} DS Logistik · Bielstrasse 20, 4500 Solothurn · <a href="/#/impressum" className="hover:text-primary">Impressum</a></p>
      </footer>
    </div>
  );
}
